module.exports = __webpack_public_path__ + "static/media/homepage-crowd.64691732.svg";